import React, { useLayoutEffect, useRef, useState } from 'react';
var LABEL_PADDING = 12;
export var useLinkLabel = function (id, label, highlighted) {
    var linkPathRef = useRef(null);
    var linkLabelRef = useRef(null);
    var _a = useState(0), linkLength = _a[0], setLinkLength = _a[1];
    var _b = useState(0), labelLength = _b[0], setLabelLength = _b[1];
    useLayoutEffect(function () {
        if (linkPathRef.current) {
            setLinkLength(linkPathRef.current.getTotalLength());
        }
        if (linkLabelRef.current) {
            setLabelLength(linkLabelRef.current.getComputedTextLength());
        }
    });
    var labelLongerThanLink = !labelLength || (labelLength + LABEL_PADDING) > linkLength;
    // How far along the path the Text will start
    var startOffset = labelLongerThanLink ? (LABEL_PADDING / 2) : (linkLength - labelLength) / 2;
    // How much of the path the Text uses
    var textElementLength = labelLongerThanLink ? linkLength - LABEL_PADDING : labelLength;
    // How much of the path the Text does not use
    var remainingNonTextPath = linkLength - textElementLength - LABEL_PADDING;
    // Specify the size of the path dashes so that the path is only drawn before and after the text, NOT over the text
    // We make stroke dash array with exactly three values - space before text, space for text, space after text
    var pathStrokeDashArray = !label || !highlighted ? undefined :
        remainingNonTextPath / 2 + " " + (textElementLength + LABEL_PADDING) + " " + remainingNonTextPath / 2;
    var labelElement = highlighted && (React.createElement("text", { className: 'link__label', ref: linkLabelRef, textLength: textElementLength, lengthAdjust: undefined, dy: '4' },
        React.createElement("textPath", { href: "#" + id, startOffset: startOffset }, label)));
    return {
        linkPathRef: linkPathRef,
        pathStrokeDashArray: pathStrokeDashArray,
        labelElement: labelElement,
    };
};
//# sourceMappingURL=useLinkLabel.js.map